module.exports = __webpack_public_path__ + "static/react-c3.8c74da61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/react-c3.png
// module id = 446
// module chunks = 111930841657428